import React from "react";
import { render } from "react-dom";
import assertContainerElement from "Utils/assertContainerElement";
import "Validation/yup/methods";
import HeaderCta from "./HeaderCta";
import initHappyPeopleSection from "../Components/Sections/HappyPeopleSection";

import "Assets/img/SupplyLP/banner/line.svg";
import "Styles/Pages/supplylp.scss";
import initHeroAnimation from "./initHeroAnimation";

initHeroAnimation();

let hasTrackedOpenVPV = false;

const trackVPV = () => {
   if (!hasTrackedOpenVPV) {
      LSHelper.ga.trackVPV({
         pageName: "/vpv/sys/join-popup",
      });
      hasTrackedOpenVPV = true;
   }
};

const headerCtaElements = document.getElementById("supplylp-hero-cta");
assertContainerElement(headerCtaElements);
render(<HeaderCta trackVPV={trackVPV} variant="opacity" buttonVariant="primary-inverted-on-dark" placeholder="Your street address" />, headerCtaElements);

const bannerCtaElements = document.getElementById("supplylp-banner-cta");
assertContainerElement(bannerCtaElements);
render(<HeaderCta trackVPV={trackVPV} variant="opacity" placeholder="Your business name or address" listSpaceText="Start for free" />, bannerCtaElements);

initHappyPeopleSection();